export const INVITE_STEP_ROUTES = {
  1: '/invite/set-user-info',
} as const;
